'use es6';

import { apiPaths } from './utils/urlValidationAPIPaths';
import makeUrlValidationAPIClient from './utils/makeUrlValidationAPIClient';
export const validateUrl = makeUrlValidationAPIClient(apiPaths.URL, 'url');